<template>
	<GmapCustomMarker
		:marker="{
			lat: markerOptions.centroid.lat,
			lng: markerOptions.centroid.long,
		}"
	>
		<div
			class="container__marker__grupo__de__plantios"
			@click.stop
		>
			<div class="container__marker__grupo__de__plantios__titulo">
				<i
					class="fas fa-caret-left"
					@click="grupoAnterior"
				/>
				<p>{{ markerOptions.estrato }}</p>
				<i
					class="fas fa-caret-right"
					@click="proximoGrupo"
				/>
			</div>
			<div class="container__marker__grupo__de__plantios__conteudo">
				<p>{{ $t('area') }}</p>
				<p>{{ markerOptions.area }} (ha)</p>
			</div>
			<div class="container__marker__grupo__de__plantios__conteudo">
				<p>{{ $t('plantationsNumber') }}</p>
				<p>{{ markerOptions.numeroDePlantios }}</p>
			</div>
			<Button
				:label="$t('editPlanning')"
				@click="editarPlanejamentoDoEstrato"
			/>
		</div>
	</GmapCustomMarker>
</template>

<script>
import Button from '../../../../../components/Button/Button'
import GmapCustomMarker from 'vue2-gmap-custom-marker'

export default {
	components: {
		Button,
		GmapCustomMarker,
	},
	props: {
		markerOptions: {
			type: Object,
			required: true,
		},
		grupoAnterior: {
			type: Function,
			required: true,
		},
		proximoGrupo: {
			type: Function,
			required: true,
		},
	},
	methods: {
		editarPlanejamentoDoEstrato() {
			this.$emit('clicouEmEditarPlanejamento')
		},
	},
}
</script>

<style scoped>
p {
	margin: 0;
}

.container__marker__grupo__de__plantios {
	background-color: white;
	padding: 0.5rem;
	min-width: 150px;
	cursor: default;
	z-index: 5000;
}

.container__marker__grupo__de__plantios__titulo {
	font-size: 0.875rem;
	color: rgb(var(--color-primary));
	font-weight: 700;
	display: flex;
	justify-content: space-around;
	align-items: center;
}

.container__marker__grupo__de__plantios__titulo i {
	cursor: pointer;
	font-size: 1.5rem;
}

.container__marker__grupo__de__plantios__conteudo {
	font-size: 0.75rem;
}

.container__marker__grupo__de__plantios__conteudo p:nth-child(odd) {
	color: rgb(var(--color-primary));
	margin-bottom: 0.25rem;
}

.container__marker__grupo__de__plantios__conteudo > p:nth-child(even) {
	color: black;
	margin-bottom: 0.5rem;
	font-size: 0.875rem;
}
</style>
